import React from 'react'
import PropTypes from 'prop-types'
import { sizes } from '@qflow/theme'

export function CopyToClipbaord({
  size = sizes.SMALL_MEDIUM,
  colour = 'currentColor',
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="-1 0 14 14"
      style={{ width: size, height: size }}
      {...props}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M10.9996 0H2.62463C2.55588 0 2.49963 0.05625 2.49963 0.125V1C2.49963 1.06875 2.55588 1.125 2.62463 1.125H10.3746V11.875C10.3746 11.9438 10.4309 12 10.4996 12H11.3746C11.4434 12 11.4996 11.9438 11.4996 11.875V0.5C11.4996 0.223437 11.2762 0 10.9996 0ZM8.99963 2H0.999634C0.723071 2 0.499634 2.22344 0.499634 2.5V10.7922C0.499634 10.925 0.552759 11.0516 0.646509 11.1453L3.35432 13.8531C3.3887 13.8875 3.42776 13.9156 3.46995 13.9391V13.9688H3.53557C3.59026 13.9891 3.64807 14 3.70745 14H8.99963C9.2762 14 9.49963 13.7766 9.49963 13.5V2.5C9.49963 2.22344 9.2762 2 8.99963 2ZM3.46838 12.3781L2.12307 11.0312H3.46838V12.3781ZM8.37463 12.875H4.46838V10.6562C4.46838 10.3109 4.1887 10.0312 3.84338 10.0312H1.62463V3.125H8.37463V12.875Z"
        fill={colour}
      />
    </svg>
  )
}

CopyToClipbaord.propTypes = {
  colour: PropTypes.string,
  size: PropTypes.string
}
